import { CustomerProfilePage } from '@/pages/customer-portal/profile/CustomerProfilePage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer/_customer-authenticated/profile')({
	component: CustomerProfileRoute,
});

function CustomerProfileRoute() {
	return <CustomerProfilePage />;
}
